import { createElement } from 'react';

interface WeaveBannerProps extends React.HTMLAttributes<HTMLElement> {
	text: string | React.ReactNode;
	closeButtonAriaLabel?: string;
	closeButton?: boolean;
	variant?: 'forma-neutral' | 'info' | 'warning' | 'error' | 'complete';
	density?: 'high' | 'medium';
	closeClick?: () => void;
	closeButtonExplain?: string;
}

export function WeaveBanner({
	className,
	text,
	closeButtonAriaLabel,
	closeButton = false,
	variant = 'forma-neutral',
	density = 'high',
	closeClick,
	closeButtonExplain,
}: WeaveBannerProps) {
	return createElement(
		'weave-banner',
		{
			className,
			text,
			closeButtonAriaLabel,
			variant,
			density,
			closeclick: closeClick,
			'close-button': closeButton,
			'close-button-explain': closeButtonExplain,
		},
		text
	);
}
